import { CSSProperties } from "react"
import { IAgTechGridItem } from "../Data/AgTechGridData"
import { AgTechGridEntity } from "../Data/AgTechGridEntities"

export type AgTechGridItemGroup<TItem extends IAgTechGridItem, TGroupKey> = {
    groupKey: TGroupKey,
    itemsInGroup: AgTechGridEntity<TItem>[],
    groupText?: string,
    groupHeader?: (itemGroupKey: TGroupKey, itemsInGroup: AgTechGridEntity<TItem>[]) => React.ReactNode
}

export type AgTechGridGroupingConfiguration<TItem extends IAgTechGridItem, TGroupKey> = {
    group: (item: TItem) => TGroupKey,
    groupText?: (itemGroupKey: TGroupKey, itemsInGroup: AgTechGridEntity<TItem>[]) => string,
    groupHeader?: (itemGroupKey: TGroupKey, itemsInGroup: AgTechGridEntity<TItem>[]) => React.ReactNode,
    offset?: number,
    showGroupHeader?: (
        itemGroupKey: TGroupKey,
        itemsInGroup: AgTechGridEntity<TItem>[],
        groupText?: string
    ) => boolean,
    sortGroups?: (a: TGroupKey, b: TGroupKey) => number
}

/// Grid Header Component

export type AgTechGridGroupHeaderRowProps<TItem extends IAgTechGridItem, TGroupKey> = {
    groupKey: any,
    groupItems: AgTechGridEntity<TItem>[],
    groupHeaderText?: string,
    groupHeaderContent?: (itemGroupKey: TGroupKey, itemsInGroup: AgTechGridEntity<TItem>[]) => React.ReactNode,
    style?: CSSProperties
}

export const AgTechGridGroupHeaderRow = <TItem extends IAgTechGridItem, TGroupKey>(
    props: AgTechGridGroupHeaderRowProps<TItem, TGroupKey>
) => {
    return (
        <div className={`bg-slate-100 border first:border-t-0 flex`} style={props.style}>
            {props.groupHeaderContent ? props.groupHeaderContent(props.groupKey, props.groupItems) : (
                <div className="flex-row items-center font-semibold text-sm px-3 flex">
                    {props.groupHeaderText ? props.groupHeaderText : props.groupKey.toString()}
                </div>
            )}
        </div>
    )
}

export const AgTechGridGroupHeaderBadge = (props: { text: string, width?: number, classes?: string }) => {
    return (
        <h1
            className={`tall centered text-sm font-semibold px-4 mr-3 flex ${props.classes ?? ''}`}
            style={{ width: props.width ?? undefined }}
        >
            {props.text}
        </h1>
    )
}